import { Menu } from '@mantine/core';
import { Icon } from '@uag/react-core';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/shallow';

import { ActionShortcutHint } from 'app/modules/wallforming/components/input-binding/ActionShortcutHint';
import { InputActionId } from 'app/modules/wallforming/components/input-binding/types/inputActionId';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

interface LockViewProps {
    setLocked: boolean;
}

export const LockView = ({ setLocked }: LockViewProps) => {
    const { t } = useTranslation();

    const { isMainCameraLocked, handleLockCameraControls } = usePlacementStore(
        useShallow((state) => ({
            isMainCameraLocked: state.isMainCameraLocked,
            handleLockCameraControls: state.handleLockCameraControls
        }))
    );

    return (
        <Menu.Item
            disabled={setLocked ? isMainCameraLocked : !isMainCameraLocked}
            leftSection={
                <Icon
                    className="action-menu-entry-decoration action-menu-entry-decoration-icon"
                    icon={setLocked ? 'lock' : 'lock_open'}
                />
            }
            rightSection={
                <ActionShortcutHint
                    actionId={setLocked ? InputActionId.CameraLockToggle : InputActionId.CameraUnlockToggle}
                />
            }
            onClick={() => handleLockCameraControls(setLocked)}
        >
            {setLocked ? t('buttonLockView') : t('buttonUnlockView')}
        </Menu.Item>
    );
};
